var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 783,
    viewBox: "0 0 430 783",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.507 5.86541C84.0037 33.6569 -142.675 76.4943 -301.871 250.816C-322.684 273.519 -342.067 297.493 -359.907 322.6C-378.435 348.559 -394.716 376.051 -408.575 404.777C-425.685 440.651 -438.355 478.853 -443.712 518.221C-452.629 583.825 -439.614 640.95 -412.141 685.027C-397.488 708.635 -378.177 729.01 -355.388 744.907C-332.599 760.804 -306.811 771.89 -279.598 777.488C-242.472 785.313 -201.839 783.662 -160.368 770.621C-138.786 764.086 -118.147 754.771 -98.9701 742.909C-0.154848 667.186 29.6779 606.36 113.931 579.15C241.706 537.884 373.935 613.391 521.713 667.186C602.591 696.629 696.543 714.573 826.484 661.996C833.14 659.31 839.673 656.456 846.084 653.436C938.056 610.233 988.657 553.142 1024.03 490.483C1058.06 430.027 1072.47 360.484 1065.25 291.47C1058.91 227.924 985.045 51.7621 985.045 51.7621C985.045 51.7621 603.148 -18.2768 361.507 5.86541Z",
    fill: "url(#paint0_linear_1_3752)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3752",
    x1: 502.575,
    y1: 1046.47,
    x2: 372.918,
    y2: 134.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B67CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731023,
    stopColor: "#0DC3EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector16);
export default __webpack_public_path__ + "static/media/vector16.4fc56bb5583b1127c7cad5b7cb9601ce.svg";
export { ForwardRef as ReactComponent };